module.exports = __webpack_public_path__ + "img/menu-bg4.9c6d8e30.png";